import React from 'react';
import '@fontsource/lato';
export const TimelineListItemTitleText = (props) => {
    const { titleText } = props;
    if (titleText === 'Task Completed') {
        return (React.createElement("div", { style: {
                color: '#000000DE',
                fontFamily: 'Lato, sans-serif',
                fontWeight: '700',
                fontSize: '16px'
            } },
            "Task ",
            React.createElement("span", { style: { color: '#2E7D32' } }, "Completed")));
    }
    else {
        return (React.createElement("div", { style: {
                color: '#000000DE',
                fontFamily: 'Lato, sans-serif',
                fontWeight: '700',
                fontSize: '16px'
            } }, titleText));
    }
};
